// extracted by mini-css-extract-plugin
module.exports = {"cuvette":"style_cuvette__3TJiW","image":"style_image__3aPLx"};